import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class HttpStatusService {

  progress: BehaviorSubject<number> = new BehaviorSubject(0)

}
